import { render } from "./InvoiceStatistics.vue?vue&type=template&id=29055980&scoped=true"
import script from "./InvoiceStatistics.vue?vue&type=script&lang=js"
export * from "./InvoiceStatistics.vue?vue&type=script&lang=js"

import "./InvoiceStatistics.vue?vue&type=style&index=0&id=29055980&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29055980"]])

export default __exports__